export default __webpack_public_path__ + "static/media/wireframes.8c703980.jpg";